var map = {
	"./google-laurel-da-DK.svg": 4659,
	"./google-laurel-de-DE.svg": 70817,
	"./google-laurel-en-GB.svg": 49452,
	"./google-laurel-en-US.svg": 96889,
	"./google-laurel-es-ES.svg": 78933,
	"./google-laurel-es-MX.svg": 25383,
	"./google-laurel-fr-FR.svg": 37311,
	"./google-laurel-it-IT.svg": 2020,
	"./google-laurel-nb-NO.svg": 97408,
	"./google-laurel-nl-NL.svg": 31779,
	"./google-laurel-pl-PL.svg": 11990,
	"./google-laurel-pt-BR.svg": 11221,
	"./google-laurel-pt-PT.svg": 84963,
	"./google-laurel-sv-SE.svg": 76192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67868;